module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAyOCAxOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0wIDBoMjh2Mkgwek0wIDhoMjh2Mkgwek0wIDE2aDI4djJIMHoiLz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/components/MenuButton/icon.svg
// module id = 412
// module chunks = 0